// extracted by mini-css-extract-plugin
export default {"p":"p--LB9mQp2Uw6Rvqq5v7TA3"};